import { ignore } from './data/keys';

//Groups DEVC entries by device
async function groupDevices(klv) {
  const result = {};
  for (const d of klv.DEVC || []) {
    if (d != null) {
      //Delete TICK and potentially other unused keys
      ignore.forEach(i => {
        if (d.hasOwnProperty(i)) delete d[i];
      });
      //Save to results inside device id key
      if (result[d.DVID]) result[d.DVID].DEVC.push(d);
      else result[d.DVID] = { DEVC: [d], interpretSamples: 'DEVC' };
    }
  }
  return result;
}

export default groupDevices;
